/**
 * @deprecated use v3 version of this component instead
 */
export function getNestedValue(rowData, key) {
  const nestedKeys = key.split('.');
  let data = rowData;
  for (const nestedKey of nestedKeys) {
    if (data === undefined || data === null || typeof data !== 'object') {
      return '';
    }
    data = data[nestedKey];
    if (data === undefined) {
      return '';
    }
  }
  if (typeof data === 'number') {
    return data.toString();
  } else {
    return data;
  }
}
/**
 * @deprecated use v3 version of this component instead
 */
export function getMetadataArray(rowData, key) {
  const nestedKeys = key.split('.');
  let data = rowData;
  for (const nestedKey of nestedKeys) {
    if (data === undefined || data === null || typeof data !== 'object') {
      return undefined;
    }
    data = data[nestedKey];
    if (data === undefined) {
      return undefined;
    }
  }
  return data;
}
/**
 * @deprecated use v3 version of this component instead
 */
export function sortColumnDefinitions(columnDefinitions, settings) {
  return columnDefinitions.sort((a, b) => {
    const orderA = settings.columns[a.key]?.order;
    const orderB = settings.columns[b.key]?.order;
    if (orderA !== undefined && orderB !== undefined) {
      return orderA - orderB;
    }
    if (orderA !== undefined) {
      return -1;
    }
    if (orderB !== undefined) {
      return 1;
    }
    return 0;
  });
}
